import React, { Component } from 'react';
import * as Constants from '../../../../utilities/constants/Constants';
import './ProductList.scss';
import { Icons } from '../../../../utilities/Icons/Icons';

class LaptopList extends Component {
  constructor() {
    super();
    this.state = {
      redraw: false
    };
  }

  componentDidMount() {
    this.redraw();
    document.addEventListener('keydown', this.handleUpDownArrowKey);
  }

  componentDidUpdate(prevProps) {
    const { query } = this.props;
    if (prevProps.query !== query) {
      this.redraw();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleUpDownArrowKey);
  }

  redraw = () => {
    const { redraw } = this.state;
    this.setState({ redraw: !redraw });
  };

  handleUpDownArrowKey = event => {
    if (event.keyCode === 38) {
      this.onScrollUp();
    } else if (event.keyCode === 40) {
      this.onScrollDown();
    }
  };

  onScrollUp = () => {
    this.getElement('scroll-product-list').scrollTop -= 130;
  };

  onScrollDown = () => {
    this.getElement('scroll-product-list').scrollTop += 130;
  };

  getElement = id => {
    if (id && document.getElementById(id)) {
      return document.getElementById(id);
    }
    return null;
  };

  handleShowAll = family => {
    const { completeProductList, pageController } = this.props;
    const list = this.getcompleteProductList(family);
    completeProductList(list);
    pageController(Constants.PRODUCT_LIST_PAGE);
  };

  getcompleteProductList = familyName => {
    const { data } = this.props;
    let completeProductList;
    data.forEach(element => {
      if (element[0].laptopFamily == familyName) {
        completeProductList = element;
      }
    });
    return completeProductList;
  };

  onScroll = () => {
    this.redraw();
  };

  render() {
    const {
      data,
      isSingleFamilyModels,
      searchResult,
      handleSingleProduct,
      singleProductNavigation
    } = this.props;
    // const { multiCanvasPopoverStatus } = this.state;
    const isSingle = handleSingleProduct(data);
    if (isSingle) {
      singleProductNavigation(data);
    }
    if (isSingleFamilyModels()) {
      this.handleShowAll(searchResult[0][0].laptopFamily);
    }

    return (
      <div className='procuct-List-container' id='scroll-product-list'>
        {searchResult.length > 0
          ? searchResult
              .sort((a, b) => (a[0].laptopFamily > b[0].laptopFamily ? 1 : -1))
              .map(item => (
                <div className='position-relative'>
                  <span
                    role='button'
                    tabIndex='0'
                    className='d-flex justify-content-between product-title-container'
                    onClick={() => this.handleShowAll(item[0].laptopFamily)}
                    onKeyPress={() => {}}
                  >
                    <div className='d-flex align-items-center'>
                      <img
                        className='laptop-icon'
                        src={Icons.laptop_icon}
                        alt='laptop'
                      />

                      <div className='group-name'>
                        {item[0].laptopFamily === ''
                          ? 'Others'
                          : item[0].laptopFamily}
                      </div>
                    </div>

                    <img src={Icons.next_arrow_blue} alt='next' />
                  </span>
                </div>
              ))
          : null}
      </div>
    );
  }
}

export default LaptopList;
